import {Component,ComponentRef,Injector,Input,OnInit,Type,ViewChild,ViewContainerRef} from '@angular/core';
import {ItemTitleComponent} from '@share/component/affichage-hierarchique/title-components/item-title/item-title.component';

/**
 * Composant générique permettant d'afficher un autre composant passé en paramètre
 *
 * @author Laurent SCIMIA
 * @date 01/12/2023
 */
@Component({
	host: {'data-test-id': 'component-holder'},
	selector: 'component-holder',
	template: '<ng-template #holder></ng-template>'
})
export class ComponentHolderComponent<T> implements OnInit {
	/** Composant à afficher */
	@Input() composant!: Type<ItemTitleComponent<T>>;

	/** Inputs pour le composant à afficher */
	@Input() inputs!: Record<string,{libelle: string, infos: T}>;

	/** Récepteur de composant */
	@ViewChild('holder',{read: ViewContainerRef,static: true}) private holder!: ViewContainerRef;


	/**
	 * Constructeur
	 */
	constructor() {
	}

	/** Initialisation */
	ngOnInit(): void {
		//Création du composant à injecter
		let component: ComponentRef<ItemTitleComponent<T>> = this.createComponent();

		//Ajout des inputs du composant
		component.instance.input = this.inputs;

		//Ajout du composant au DOM
		this.holder.insert(component.hostView);
	}

	/**
	 * Création du composant
	 */
	createComponent(): ComponentRef<ItemTitleComponent<T>> {
		//Récupération de l'injecteur
		const injector = Injector.create({
			providers: [],
			parent: this.holder.injector,
		});

		//Création du composant
		const componentRef = this.holder.createComponent<ItemTitleComponent<T>>(
			this.composant,
			{
				injector: injector
			}
		);

		return componentRef;
	}
}